import {
  ADMIN_BOOKING_DETAILS_START,
  ADMIN_BOOKING_DETAILS_SUCCESS,
  ADMIN_BOOKING_DETAILS_ERROR,
  ADMIN_CANCEL_BOOKING_DETAILS_START,
  ADMIN_CANCEL_BOOKING_DETAILS_SUCCESS,
  ADMIN_CANCEL_BOOKING_DETAILS_ERROR,
  ADMIN_CANCEL_BOOKING_START,
  ADMIN_CANCEL_BOOKING_SUCCESS,
  ADMIN_CANCEL_BOOKING_ERROR,
  ADMIN_SHARE_DOCUMENT_START,
  ADMIN_SHARE_DOCUMENT_SUCCESS,
  ADMIN_SHARE_DOCUMENT_ERROR
} from '../Constants/BookingConstat'
  
  const initialState = {
    loading: false,
    booking_detail: [],
    cancel_booking_detail: [],
    canceled_booking: [],
    share_document: []
  };
  
  export default function faqOperatorReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case ADMIN_BOOKING_DETAILS_START:
        return {
          ...state,
          loading: true,
        };
      case ADMIN_BOOKING_DETAILS_SUCCESS:
        return {
          ...state,
          booking_detail: action.payload,
          loading: false,
        };
      case ADMIN_BOOKING_DETAILS_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
        case ADMIN_CANCEL_BOOKING_DETAILS_START:
          return {
            ...state,
            loading: true,
          };
        case ADMIN_CANCEL_BOOKING_DETAILS_SUCCESS:
          return {
            ...state,
            cancel_booking_detail: action.payload,
            loading: false,
          };
        case ADMIN_CANCEL_BOOKING_DETAILS_ERROR:
          return {
            ...state,
            loading: false,
            message: action.error.message,
          };
        case ADMIN_CANCEL_BOOKING_START:
          return {
            ...state,
            loading: true,
          };
        case ADMIN_CANCEL_BOOKING_SUCCESS:
          return {
            ...state,
            canceled_booking: action.payload,
            loading: false,
          };
        case ADMIN_CANCEL_BOOKING_ERROR:
          return {
            ...state,
            loading: false,
            message: action.error.message,
          };
        case ADMIN_SHARE_DOCUMENT_START:
          return {
            ...state,
            loading: true,
          };
        case ADMIN_SHARE_DOCUMENT_SUCCESS:
          return {
            ...state,
            share_document: action.payload,
            loading: false,
          };
        case ADMIN_SHARE_DOCUMENT_ERROR:
          return {
            ...state,
            loading: false,
            message: action.error.message,
          };
      default:
        return state;
    }
  }
  